import PlaneAction from "./PlaneAction.js";
import {climbVy} from "../planeSlice.js";

export default class Climb extends PlaneAction {
    constructor(planeId, targetAltitude) {
        super(planeId);
        this.targetAltitude = targetAltitude;
    }

    execute() {
        this.log(`Climbing to ${this.targetAltitude}ft`);
        this.dispatch(climbVy({altitude: this.targetAltitude}));
    }

    isComplete = () => true;
}

